import React from "react";

import { checkoutText } from "../DataFiles/standardText";
import CheckoutFormContainer from "./CheckoutFormContainer";

import "../MainForm/MainForm.css";

const SimpleSubmit = (props) => {
  const { formData, onPageUpdate, currentScreen } = props;

  return (
    <div className="checkoutContainer">
      <div className="checkoutFormImage"></div>
      <div className="checkoutForm">
        <div
          className="messageHeader"
          dangerouslySetInnerHTML={{ __html: checkoutText.header }}
        />
        <CheckoutFormContainer
          formData={formData}
          onPageUpdate={onPageUpdate}
          currentScreen={currentScreen}
        />
      </div>
    </div>
  );
};

export default SimpleSubmit;
